import {Controller} from '@hotwired/stimulus';

/**
 * Sélecteur à vignettes : la vignette choisie prend la classe `selected`, les autres la perdent, et
 * sa valeur (`data-value`) est écrite dans le champ caché, seul posté.
 *
 *   <div {{ stimulus_controller('image-choice') }}>
 *     <input type="hidden" name="…" value="…" {{ stimulus_target('image-choice', 'input') }}>
 *     <a href="#" data-value="left" {{ stimulus_target('image-choice', 'choice') }}
 *        {{ stimulus_action('image-choice', 'select:prevent') }}>…</a>
 *   </div>
 */
export default class extends Controller {
  static targets = ['input', 'choice'];

  select(event) {
    const chosen = event.currentTarget;

    for (const choice of this.choiceTargets) {
      choice.classList.toggle('selected', choice === chosen);
    }

    this.inputTarget.value = chosen.dataset.value;
  }
}
